/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import MuiLink from '@material-ui/core/Link';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import moment, { utc } from 'moment';
// eslint-disable-next-line no-unused-vars
import fr from 'moment/locale/fr';
import { CircularProgress } from 'react-md';
import { get } from 'lodash-es';

// eslint-disable-next-line react/prop-types
const SummaryTextItem = ({ label, value, theme = 'white', ...props }) => (
  <div className={`item ${theme}`} {...props}>
    <div className="label">{label}</div>
    <div className="value">{value}</div>
  </div>
);

SummaryTextItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  theme: PropTypes.string,
};

// eslint-disable-next-line react/prop-types
const SummaryEmptyItem = ({ visible = true, label, theme = 'white', ...props }) =>
  visible ? (
    <div className={`item ${theme}`} {...props}>
      <div className="label">{label}</div>
      <div className="value">
        <CircularProgress
          id={`summary-empty-item-${label}`}
          className="loading-anim-offer"
          scale={0.5}
          style={{ margin: '2em auto' }}
        />
      </div>
    </div>
  ) : (
    <></>
  );

SummaryEmptyItem.propTypes = {
  label: PropTypes.string,
  visible: PropTypes.bool,
  theme: PropTypes.string,
};

// eslint-disable-next-line react/prop-types
const EmptyItem = () => (
  <div className="item empty">
    <div className="label" />
    <div className="value">
      <CircularProgress
        id="summary-empty-item"
        className="loading-anim-offer"
        scale={0.5}
        style={{ margin: '2em auto' }}
      />
    </div>
  </div>
);

// eslint-disable-next-line react/prop-types
const SummaryLinkItem = ({ label, name, value, route, theme = 'white' }) => {
  const link = props => <Link to={route} {...props} />;
  return (
    <div className={`item ${theme}`}>
      <div className="label">{label}</div>
      <div className="link">
        <MuiLink
          title={name || value}
          component={React.forwardRef((props, ref) => link(props))}
          key={`summary-link-item-${label}`}
        >
          {name || value}
        </MuiLink>
      </div>
    </div>
  );
};

SummaryLinkItem.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  route: PropTypes.string,
  theme: PropTypes.string,
};

// eslint-disable-next-line react/prop-types
const SummaryBlock = ({ contract, strings = {}, i18n, contractStatus, loading, ...props }) => {
  const { isLoadingContract } = loading;
  const formatDate = ({ date }) => {
    if (typeof date === 'undefined') return undefined;
    const { dateFormat, lang } = i18n;
    moment.locale(lang || 'en');
    return utc(date).format(dateFormat);
  };

  const statusLabel = ({ status }) => {
    const statusMapping = {
      "quote": "Devis",
      "active": "Actif",
      "void": "Sans effet",
      "terminated": "Résilié",
      "declined": "Décliné",
      "hold": "Suspendu"
    }
    return statusMapping[status] ?? "Statut inconnu";
  };

  const renderOngoingProcess = () => {
    if (contract?.currentState) {
      return (
        <SummaryTextItem
          label={strings['contract.summary.ongoing_process.label'] || 'Ongoing Process'}
          value={contract.currentState}
          theme="ongoing-process"
        />
      );
    }
    return loading && loading.isLoadingContract ? <EmptyItem /> : undefined;
  };

  return (
    <div className="summary block" {...props}>
      <div className="left">
        {get(contract, 'product.id') ? (
          <SummaryLinkItem
            label={strings['contract.summary.product.label'] || 'Product'}
            value={get(contract, 'product.name')}
            route={`/products/${get(contract, 'product.id')}`}
            name={get(contract, 'com_product.rec_name')}
          />
        ) : (
          <SummaryEmptyItem label={strings['contract.summary.product.label'] || 'Product'} />
        )}
        {get(contract, 'subscriber.id') ? (
          <SummaryLinkItem
            label={strings['contract.summary.subscriber.label'] || 'Subscriber'}
            value={get(contract, 'subscriber.code')}
            route={`/party/${get(contract, 'subscriber.code')}`}
            name={get(contract, 'subscriber.name')}
          />
        ) : (
          <SummaryEmptyItem label={strings['contract.summary.subscriber.label'] || 'Subscriber'} />
        )}
        {get(contract, 'startDate') ? (
          <SummaryTextItem
            label={strings['contract.summary.start_date.label'] || 'Start Date'}
            value={formatDate({ date: get(contract, 'startDate') })}
          />
        ) : (
          <SummaryEmptyItem label={strings['contract.summary.start_date.label'] || 'Start Date'} />
        )}
        {get(contract, 'endDate') ? (
          <SummaryTextItem
            label={strings['contract.summary.end_date.label'] || 'End Date'}
            value={formatDate({ date: get(contract, 'endDate') })}
          />
        ) : (
          <SummaryEmptyItem
            visible={isLoadingContract}
            label={strings['contract.summary.end_date.label'] || 'End Date'}
          />
        )}
        {get(contract, 'contractNumber') ? (
          <SummaryTextItem
            label={get(strings, 'contract.summary.contract_number.label') || 'Contract'}
            value={get(contract, 'contractNumber')}
          />
        ) : undefined}
        {get(contract, 'quoteNumber') ? (
          <SummaryTextItem
            label={get(strings, 'contract.summary.quote_number.label') || 'Devis'}
            value={get(contract, 'quoteNumber')}
          />
        ) : undefined}
      </div>
      <div className="right">
        {renderOngoingProcess()}
        {get(contract, 'contractStatus') ? (
          <SummaryTextItem
            label={strings['contract.summary.status.label'] || 'Status'}
            value={statusLabel({ status: get(contract, 'contractStatus') })}
            theme={get(contract, 'contractStatus')}
          />
        ) : (
          <SummaryEmptyItem label={strings['contract.summary.status.label'] || 'Status'} />
        )}
      </div>
    </div>
  );
};

SummaryBlock.propTypes = {
  contract: PropTypes.object,
  strings: PropTypes.object,
  i18n: PropTypes.object,
  contractStatus: PropTypes.any,
  loading: PropTypes.object,
};

export default SummaryBlock;
